var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[(_vm.company != null)?_c('p',[_vm._v(_vm._s(_vm.companyName))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }